import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "maxLength", "buttonText", "showType", "notice", "tabValue"];

/* eslint-disable no-unused-expressions */
import React, { useMemo, useState, useEffect } from 'react';
import classnames from 'classnames';
import { dispatch } from '@/store';
import Content from '@/components/Content';
import { Iconfont } from '@/baseComponents';
import { useNotice } from '@/components/Button';
import { HAD_NOTICE } from '@/constants';

const renderBy = status => node => {
  return status ? node : null;
};

const Text = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    maxLength,
    buttonText,
    showType = 'expand',
    notice,
    tabValue = 1
  } = props,
        others = _objectWithoutProperties(props, _excluded); // const [notice = {}] = useNotice();


  const [showMore, setShowMore] = useState(false);
  const {
    header = '',
    noticeDetailList = []
  } = notice || {};
  const cls = classnames({
    'components-text-render': false,
    [className]: !!className
  });
  const data = useMemo(() => {
    if (showMore) {
      return noticeDetailList;
    }

    if (maxLength) {
      return noticeDetailList.slice(0, maxLength);
    }

    return noticeDetailList;
  }, [showMore, noticeDetailList, maxLength]);

  const onClickFooter = () => setShowMore(!showMore);

  useEffect(() => {
    // dispatch(HAD_NOTICE, true);
    // setTimeout(()=>{
    const $block = document.querySelectorAll('.ql-indent-1');
    Array.from($block).forEach($item => {
      const $prev = $item.previousElementSibling;
      const $next = $item.nextElementSibling;

      if (!($prev !== null && $prev !== void 0 && $prev.classList.contains('ql-indent-1'))) {
        $item === null || $item === void 0 ? void 0 : $item.classList.add('ql-indent-1-first');
      }

      if (!($next !== null && $next !== void 0 && $next.classList.contains('ql-indent-1'))) {
        $item === null || $item === void 0 ? void 0 : $item.classList.add('ql-indent-1-last');
      }
    }); //  },1000)
  }, []);
  useEffect(() => {
    setShowMore(showType === 'expand');
  }, [showType]);

  const renderHeader = () => {
    const dangerouslySetInnerHTML = {
      __html: header
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "text-header",
      dangerouslySetInnerHTML: dangerouslySetInnerHTML
    });
  };

  const renderBody = () => {
    const html = data.reduce((res = '', item = {}) => {
      const {
        noticeContent = ''
      } = item;
      return `${res}<div style="opactity: 0; height: 15px;"></div>${noticeContent}`;
    }, '');
    const dangerouslySetInnerHTML = {
      __html: html
    };
    return /*#__PURE__*/React.createElement(Content, {
      className: "text-body",
      dangerouslySetInnerHTML: dangerouslySetInnerHTML,
      contentFrom: "popup",
      tabValue: tabValue
    });
  };

  const renderFooter = () => {
    if (!maxLength) {
      return null;
    }

    if (maxLength >= noticeDetailList.length) {
      return null;
    }

    const footerCls = classnames({
      'text-footer': true,
      reverse: !!showMore
    });
    return /*#__PURE__*/React.createElement("div", {
      className: footerCls,
      onClick: onClickFooter
    }, /*#__PURE__*/React.createElement(Iconfont, {
      className: "icon",
      type: "biansechakangengduo"
    }), /*#__PURE__*/React.createElement("div", {
      className: "footer-title",
      "data-title": buttonText
    }));
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), renderHeader(), renderBody(), renderFooter());
});
Text.displayName = 'InfoContent';
export default Text;